import type { ExpandableCatalog } from './models/catalog';
import type { FieldPattern, FieldValue } from './schemas/fieldPatterns.schemas';

export function normalizeFieldText(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function resolveFieldValueText(
  value: FieldValue | null | undefined,
  catalog?: ExpandableCatalog
): string {
  if (!value) return '';

  if (value.kind === 'option') {
    if (catalog) {
      const match = catalog.options.find((option) => option.id === value.optionId);
      if (match) return match.label;
    }
    return value.optionId;
  }

  if (value.kind === 'custom' || value.kind === 'text') {
    return normalizeFieldText(value.text);
  }

  return '';
}

export function isFieldValueEmpty(value: FieldValue | null | undefined): boolean {
  if (!value) return true;
  if (value.kind === 'option') return value.optionId.trim().length === 0;
  if (value.kind === 'custom' || value.kind === 'text') {
    return normalizeFieldText(value.text).length === 0;
  }
  return true;
}

export function normalizeFieldValue(
  value: FieldValue | null | undefined
): FieldValue | null | undefined {
  if (!value) return value;
  if (value.kind === 'custom') {
    return { kind: 'custom', text: normalizeFieldText(value.text) };
  }
  if (value.kind === 'text') {
    return { kind: 'text', text: normalizeFieldText(value.text) };
  }
  return value;
}

export function isFieldValueCompatible(
  pattern: FieldPattern,
  value: FieldValue | null | undefined
): boolean {
  if (!value) return true;
  if (pattern === 'closed_enum') return value.kind === 'option';
  if (pattern === 'open_enum') return value.kind === 'option' || value.kind === 'custom';
  return value.kind === 'text';
}
